import {SwaggerRepository} from "@/apps/branch-api/api/swagger";

export default {
    swagger: new SwaggerRepository(),
}